module.exports = __webpack_public_path__ + "static/media/close_header.5edee8df.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/close_header.png
// module id = 738
// module chunks = 0 1